<template>
	<el-menu background-color="#f7f9ff" class="border-0 my-1 me-2" router :default-active="activeMenu">
		<template v-for="m in listMenu" :key="m.path">
			<el-sub-menu v-if="m.meta.type === 'sub-menu'" :index="m.path">
				<template #title>
					<el-icon><i :class="m.meta.icon"></i></el-icon>
					<span>{{ m.meta.menuTitle }}</span>
				</template>
				<template v-if="m.children?.length">
					<el-menu-item v-for="c in m.children" :key="c.path" :index="`${m.path}/${c.path}`" :route="{ name: c.name }" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasNavbar">
						{{ c.meta.menuTitle }}
					</el-menu-item>
				</template>
			</el-sub-menu>
			<el-menu-item v-else :index="m.path" :route="{ name: m.name }" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasNavbar">
				<el-link underline="never">
					<el-icon><i :class="m.meta.icon"></i></el-icon>{{ m.meta.menuTitle }}
				</el-link>
			</el-menu-item>
		</template>
	</el-menu>
</template>

<script>
export default {
	name: "AppMenu",
	computed: {
		activeMenu() {
			const matched = this.$route.matched;
			if (matched.length > 0) {
				const last = matched[matched.length - 1];
				if (last.meta && last.meta.activeMenu) {
					return typeof last.meta.activeMenu === "function" ? last.meta.activeMenu(this.$route) : last.meta.activeMenu;
				}
			}
			return this.$route.path;
		},
		user() {
			return this.$store.getters.getUser;
		},
		roles() {
			return this.$store.getters.getRoles;
		},
		listMenu() {
			const listRoute = this.$router.options.routes;
			const filteredMenu = listRoute.filter((r) => {
				const { type, allowedTypes = [], allowedRoles = [] } = r.meta;

				const isAllowedType = !allowedTypes.length || allowedTypes.includes(this.user?.type);
				const isAllowedRole = !allowedRoles.length || this.roles?.some((r) => allowedRoles.includes(r.role)) || allowedRoles.includes(this.user?.type);

				return (type === "menu" || type === "sub-menu") && isAllowedType && isAllowedRole;
			});
			return filteredMenu;
		},
	},
};
</script>

<style scoped></style>
